export function isCompatibleVersionInvalid(manifestVersion: string, newVersion: string): boolean {
  const parseVersion = (version: string) => {
    if (!version) return { major: 0, minor: 0, develop: 0 };
    const parts = version.split(',');
    if (parts.length < 2) return { major: 0, minor: 0, develop: 0 };
    const subParts = parts[1].split('.');
    if (subParts.length < 3) return { major: 0, minor: 0, develop: 0 };
    const [major, minor, develop] = subParts.map(Number);
    return { major, minor, develop };
  };

  const manifest = parseVersion(manifestVersion);
  const compatible = parseVersion(newVersion);

  // Compare major
  if (compatible.major !== manifest.major) {
    return compatible.major > manifest.major;
  }

  // Compare minor
  if (compatible.minor !== manifest.minor) {
    return compatible.minor > manifest.minor;
  }

  // Compare develop
  return compatible.develop > manifest.develop;
}
